import WebFont from 'webfontloader';
import Footer from './components/Layouts/Footer/Footer';
import FooterInfoBar from './components/Layouts/Footer/FooterInfoBar';
import Header from './components/Layouts/Header/Header';
import Login from './components/User/Login';
import AdminEntry from './components/User/AdminEntry';
import VerifyOtp from './components/User/VerifyOtp';
import LoginWithOtp from './components/User/LoginWithOtp';
import Register from './components/User/Register';
import { Routes, Route, useLocation } from 'react-router-dom';
import { loadUser } from './actions/userAction';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import UpdateProfile from './components/User/UpdateProfile';
import UpdatePassword from './components/User/UpdatePassword';
import ManageAddresses from './components/User/ManageAddresses';
import ForgotPassword from './components/User/ForgotPassword';
import ResetPassword from './components/User/ResetPassword';
import Account from './components/User/Account';
import ProtectedRoute from './Routes/ProtectedRoute';
import Home from './components/Home/Home';
import AboutUs from './components/AboutUs/AboutUs';
import ContactUs from './components/ContactUs/ContactUs';
import LegalPageView from './components/Legal/LegalPageView';
import DownloadApp from './components/DownloadApp/DownloadApp';
import DriverDownloadApp from './components/DownloadApp/DriverDownloadApp';
import PagesTable from './components/Admin/PagesTable';
import AboutPageForm from './components/Admin/AboutPageForm';
import ContactPageForm from './components/Admin/ContactPageForm';
import LegalPageForm from './components/Admin/LegalPageForm';
import ProductDetails from './components/ProductDetails/ProductDetails';
import Products from './components/Products/Products';
import Cart from './components/Cart/Cart';
import Shipping from './components/Cart/Shipping';
import OrderConfirm from './components/Cart/OrderConfirm';
import Payment from './components/Cart/Payment';
import AlipayReturn from './components/Cart/AlipayReturn';
import TopupReturn from './components/Order/TopupReturn';
import OrderStatus from './components/Cart/OrderStatus';
import OrderSuccess from './components/Cart/OrderSuccess';
import MyOrders from './components/Order/MyOrders';
import OrderDetails from './components/Order/OrderDetails';
import EditOrder from './components/Order/EditOrder';
import MyWallet from './components/User/MyWallet';
import Dashboard from './components/Admin/Dashboard';
import MainData from './components/Admin/MainData';
import OrderTable from './components/Admin/OrderTable';
import UpdateOrder from './components/Admin/UpdateOrder';
import ProductTable from './components/Admin/ProductTable';
import TrashProductTable from './components/Admin/TrashProductTable';
import NewProduct from './components/Admin/NewProduct';
import UpdateProduct from './components/Admin/UpdateProduct';
import UserTable from './components/Admin/UserTable';
import UserOrderHistory from './components/Admin/UserOrderHistory';
import UpdateUser from './components/Admin/UpdateUser';
import NewUser from './components/Admin/NewUser';
import ReviewsTable from './components/Admin/ReviewsTable';
import SiteSettingsAdmin from './components/Admin/SiteSettingsAdmin';
import BannerSlideTable from './components/Admin/BannerSlideTable';
import BannerSlideForm from './components/Admin/BannerSlideForm';
import PromoCardTable from './components/Admin/PromoCardTable';
import PromoCardForm from './components/Admin/PromoCardForm';
import TrustPromoTable from './components/Admin/TrustPromoTable';
import TrustPromoForm from './components/Admin/TrustPromoForm';
import AdminHeader from './components/Admin/AdminHeader';
import FooterAdmin from './components/Admin/FooterAdmin';
import FooterColumnTable from './components/Admin/FooterColumnTable';
import FooterColumnForm from './components/Admin/FooterColumnForm';
import ProductSectionTable from './components/Admin/ProductSectionTable';
import ProductSectionForm from './components/Admin/ProductSectionForm';
import OfferTable from './components/Admin/OfferTable';
import OfferForm from './components/Admin/OfferForm';
import RoleTable from './components/Admin/RoleTable';
import RoleForm from './components/Admin/RoleForm';
import SplashScreenAdmin from './components/Admin/SplashScreenAdmin';
import CategoryTable from './components/Admin/CategoryTable';
import CategoryForm from './components/Admin/CategoryForm';
import BrandTable from './components/Admin/BrandTable';
import BrandForm from './components/Admin/BrandForm';
import PromoCodeTable from './components/Admin/PromoCodeTable';
import PromoCodeForm from './components/Admin/PromoCodeForm';
import ShippingAreaTable from './components/Admin/ShippingAreaTable';
import ShippingAreaForm from './components/Admin/ShippingAreaForm';
import RegionTable from './components/Admin/RegionTable';
import PaymentGatewaySettings from './components/Admin/PaymentGatewaySettings';
import InventoryLog from './components/Admin/InventoryLog';
import WalletTable from './components/Admin/WalletTable';
import WalletDetail from './components/Admin/WalletDetail';
import WalletSettings from './components/Admin/WalletSettings';
import StoreTable from './components/Admin/StoreTable';
import VendorTable from './components/Admin/VendorTable';
import VendorForm from './components/Admin/VendorForm';
import VendorAllocations from './components/Admin/VendorAllocations';
import VendorLogin from './components/Vendor/VendorLogin';
import VendorDashboard from './components/Vendor/VendorDashboard';
import DriverTable from './components/Admin/DriverTable';
import DriverForm from './components/Admin/DriverForm';
import DriverPortal from './components/Driver/DriverPortal';
import VehicleTable from './components/Admin/VehicleTable';
import VehicleForm from './components/Admin/VehicleForm';
import HeaderAdmin from './components/Admin/HeaderAdmin';
import NotificationTable from './components/Admin/NotificationTable';
import NotificationForm from './components/Admin/NotificationForm';
import Wishlist from './components/Wishlist/Wishlist';
import NotFound from './components/NotFound';

function App() {

  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith('/admin');
  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Roboto:300,400,500,600,700"]
      },
    });
  });

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  // always scroll to top on route/path change
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, [pathname])

  return (
    <>
      {isAdminRoute ? <AdminHeader /> : <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/download-app" element={<DownloadApp />} />
        <Route path="/driver-app" element={<DriverDownloadApp />} />
        <Route path="/legal/:slug" element={<LegalPageView />} />

        <Route path="/admin/pages" element={
          <ProtectedRoute isAdmin={true} permission="pages" action="view">
            <Dashboard activeTab={6}>
              <PagesTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/pages/about" element={
          <ProtectedRoute isAdmin={true} permission="pages" action="edit">
            <Dashboard activeTab={6}>
              <AboutPageForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/pages/contact" element={
          <ProtectedRoute isAdmin={true} permission="pages" action="edit">
            <Dashboard activeTab={6}>
              <ContactPageForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/pages/legal/:slug" element={
          <ProtectedRoute isAdmin={true} permission="pages" action="edit">
            <Dashboard activeTab={6}>
              <LegalPageForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/login" element={<Login />} />
        <Route path="/login/otp" element={<LoginWithOtp />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/admin" element={<AdminEntry />} />
        <Route path="/register" element={<Register />} />

        <Route path="/product/:id" element={<ProductDetails />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:keyword" element={<Products />} />

        <Route path="/cart" element={<Cart />} />

        {/* order process */}
        <Route path="/shipping" element={
          <ProtectedRoute>
            <Shipping />
          </ProtectedRoute>
        } ></Route>

        <Route path="/order/confirm" element={
          <ProtectedRoute>
            <OrderConfirm />
          </ProtectedRoute>
        } ></Route>

        <Route path="/process/payment" element={
          <ProtectedRoute>
            <Payment />
          </ProtectedRoute>
        } ></Route>

        <Route path="/order/alipay-return" element={
          <ProtectedRoute>
            <AlipayReturn />
          </ProtectedRoute>
        } ></Route>

        <Route path="/order/topup-return" element={
          <ProtectedRoute>
            <TopupReturn />
          </ProtectedRoute>
        } ></Route>

        <Route path="/orders/success" element={<OrderSuccess success={true} />} />
        <Route path="/orders/failed" element={<OrderSuccess success={false} />} />
        {/* order process */}

        <Route path="/order/:id" element={
          <ProtectedRoute>
            <OrderStatus />
          </ProtectedRoute>
        } ></Route>

        <Route path="/orders" element={
          <ProtectedRoute>
            <MyOrders />
          </ProtectedRoute>
        }></Route>

        <Route path="/order_details/:id" element={
          <ProtectedRoute>
            <OrderDetails />
          </ProtectedRoute>
        }></Route>

        <Route path="/order_details/:id/edit" element={
          <ProtectedRoute>
            <EditOrder />
          </ProtectedRoute>
        }></Route>

        <Route path="/my-wallet" element={
          <ProtectedRoute>
            <MyWallet />
          </ProtectedRoute>
        }></Route>

        <Route path="/account" element={
          <ProtectedRoute>
            <Account />
          </ProtectedRoute>
        } ></Route>

        <Route path="/account/update" element={
          <ProtectedRoute>
            <UpdateProfile />
          </ProtectedRoute>
        } ></Route>

        <Route path="/password/update" element={
          <ProtectedRoute>
            <UpdatePassword />
          </ProtectedRoute>
        } ></Route>

        <Route path="/account/addresses" element={
          <ProtectedRoute>
            <ManageAddresses />
          </ProtectedRoute>
        } ></Route>

        <Route path="/password/forgot" element={<ForgotPassword />} />

        <Route path="/password/reset/:token" element={<ResetPassword />} />

        <Route path="/wishlist" element={
          <ProtectedRoute>
            <Wishlist />
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/dashboard" element={
          <ProtectedRoute isAdmin={true}>
            <Dashboard activeTab={0}>
              <MainData />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/orders" element={
          <ProtectedRoute isAdmin={true} permission="orders" action="view">
            <Dashboard activeTab={1}>
              <OrderTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/orders/legacy" element={
          <ProtectedRoute isAdmin={true} permission="orders" action="view">
            <Dashboard activeTab={1}>
              <OrderTable legacy={true} />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/orders/trash" element={
          <ProtectedRoute isAdmin={true} superAdminOnly={true}>
            <Dashboard activeTab={1}>
              <OrderTable trash={true} />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/order/:id" element={
          <ProtectedRoute isAdmin={true} permission="orders" action="edit">
            <Dashboard activeTab={1}>
              <UpdateOrder />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/products" element={
          <ProtectedRoute isAdmin={true} permission="products" action="view">
            <Dashboard activeTab={2}>
              <ProductTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/products/trash" element={
          <ProtectedRoute isAdmin={true} permission="products" action="delete">
            <Dashboard activeTab={2}>
              <TrashProductTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/new_product" element={
          <ProtectedRoute isAdmin={true} permission="products" action="create">
            <Dashboard activeTab={3}>
              <NewProduct />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/product/:id" element={
          <ProtectedRoute isAdmin={true} permission="products" action="edit">
            <Dashboard activeTab={2}>
              <UpdateProduct />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/users" element={
          <ProtectedRoute isAdmin={true} superAdminOnly={true}>
            <Dashboard activeTab={4}>
              <UserTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/user/new" element={
          <ProtectedRoute isAdmin={true} superAdminOnly={true}>
            <Dashboard activeTab={4}>
              <NewUser />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/user/:id" element={
          <ProtectedRoute isAdmin={true} superAdminOnly={true}>
            <Dashboard activeTab={4}>
              <UpdateUser />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/user/:id/orders" element={
          <ProtectedRoute isAdmin={true} superAdminOnly={true}>
            <Dashboard activeTab={4}>
              <UserOrderHistory />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/roles" element={
          <ProtectedRoute isAdmin={true} superAdminOnly={true}>
            <Dashboard activeTab={16}>
              <RoleTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/role/new" element={
          <ProtectedRoute isAdmin={true} superAdminOnly={true}>
            <Dashboard activeTab={16}>
              <RoleForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/role/:id" element={
          <ProtectedRoute isAdmin={true} superAdminOnly={true}>
            <Dashboard activeTab={16}>
              <RoleForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/splash-screens" element={
          <ProtectedRoute isAdmin={true} permission="splashScreen" action="view">
            <Dashboard activeTab={17}>
              <SplashScreenAdmin />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/categories" element={
          <ProtectedRoute isAdmin={true} permission="categories" action="view">
            <Dashboard activeTab={4}>
              <CategoryTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/category/new" element={
          <ProtectedRoute isAdmin={true} permission="categories" action="create">
            <Dashboard activeTab={4}>
              <CategoryForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/category/:id" element={
          <ProtectedRoute isAdmin={true} permission="categories" action="edit">
            <Dashboard activeTab={4}>
              <CategoryForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/brands" element={
          <ProtectedRoute isAdmin={true} permission="brands" action="view">
            <Dashboard activeTab={4}>
              <BrandTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/brand/new" element={
          <ProtectedRoute isAdmin={true} permission="brands" action="create">
            <Dashboard activeTab={4}>
              <BrandForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/brand/:id" element={
          <ProtectedRoute isAdmin={true} permission="brands" action="edit">
            <Dashboard activeTab={4}>
              <BrandForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/reviews" element={
          <ProtectedRoute isAdmin={true} permission="reviews" action="view">
            <Dashboard activeTab={5}>
              <ReviewsTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/site-content" element={
          <ProtectedRoute isAdmin={true} permission="siteContent" action="view">
            <Dashboard activeTab={6}>
              <SiteSettingsAdmin />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/banner-slides" element={
          <ProtectedRoute isAdmin={true} permission="bannerSlides" action="view">
            <Dashboard activeTab={6}>
              <BannerSlideTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/banner-slide/new" element={
          <ProtectedRoute isAdmin={true} permission="bannerSlides" action="create">
            <Dashboard activeTab={6}>
              <BannerSlideForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/banner-slide/:id" element={
          <ProtectedRoute isAdmin={true} permission="bannerSlides" action="edit">
            <Dashboard activeTab={6}>
              <BannerSlideForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/promo-cards" element={
          <ProtectedRoute isAdmin={true} permission="promoCards" action="view">
            <Dashboard activeTab={6}>
              <PromoCardTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/promo-card/new" element={
          <ProtectedRoute isAdmin={true} permission="promoCards" action="create">
            <Dashboard activeTab={6}>
              <PromoCardForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/promo-card/:id" element={
          <ProtectedRoute isAdmin={true} permission="promoCards" action="edit">
            <Dashboard activeTab={6}>
              <PromoCardForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/trust-promos" element={
          <ProtectedRoute isAdmin={true} permission="trustPromos" action="view">
            <Dashboard activeTab={6}>
              <TrustPromoTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/trust-promo/new" element={
          <ProtectedRoute isAdmin={true} permission="trustPromos" action="create">
            <Dashboard activeTab={6}>
              <TrustPromoForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/trust-promo/:id" element={
          <ProtectedRoute isAdmin={true} permission="trustPromos" action="edit">
            <Dashboard activeTab={6}>
              <TrustPromoForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/footer" element={
          <ProtectedRoute isAdmin={true} permission="footer" action="view">
            <Dashboard activeTab={6}>
              <FooterAdmin />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/footer-columns" element={
          <ProtectedRoute isAdmin={true} permission="footer" action="view">
            <Dashboard activeTab={6}>
              <FooterColumnTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/footer-column/new" element={
          <ProtectedRoute isAdmin={true} permission="footer" action="create">
            <Dashboard activeTab={6}>
              <FooterColumnForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/footer-column/:id" element={
          <ProtectedRoute isAdmin={true} permission="footer" action="edit">
            <Dashboard activeTab={6}>
              <FooterColumnForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/product-sections" element={
          <ProtectedRoute isAdmin={true} permission="productSections" action="view">
            <Dashboard activeTab={6}>
              <ProductSectionTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/product-section/new" element={
          <ProtectedRoute isAdmin={true} permission="productSections" action="create">
            <Dashboard activeTab={6}>
              <ProductSectionForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/product-section/:id" element={
          <ProtectedRoute isAdmin={true} permission="productSections" action="edit">
            <Dashboard activeTab={6}>
              <ProductSectionForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/offers" element={
          <ProtectedRoute isAdmin={true} permission="offers" action="view">
            <Dashboard activeTab={6}>
              <OfferTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/offer/new" element={
          <ProtectedRoute isAdmin={true} permission="offers" action="create">
            <Dashboard activeTab={6}>
              <OfferForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/offer/:id" element={
          <ProtectedRoute isAdmin={true} permission="offers" action="edit">
            <Dashboard activeTab={6}>
              <OfferForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/promo-codes" element={
          <ProtectedRoute isAdmin={true} permission="promoCodes" action="view">
            <Dashboard activeTab={6}>
              <PromoCodeTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/promo-code/new" element={
          <ProtectedRoute isAdmin={true} permission="promoCodes" action="create">
            <Dashboard activeTab={6}>
              <PromoCodeForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/promo-code/:id" element={
          <ProtectedRoute isAdmin={true} permission="promoCodes" action="edit">
            <Dashboard activeTab={6}>
              <PromoCodeForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/shipping-areas" element={
          <ProtectedRoute isAdmin={true} permission="shippingAreas" action="view">
            <Dashboard activeTab={6}>
              <ShippingAreaTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/shipping-area/new" element={
          <ProtectedRoute isAdmin={true} permission="shippingAreas" action="create">
            <Dashboard activeTab={6}>
              <ShippingAreaForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/shipping-area/:id" element={
          <ProtectedRoute isAdmin={true} permission="shippingAreas" action="edit">
            <Dashboard activeTab={6}>
              <ShippingAreaForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/regions" element={
          <ProtectedRoute isAdmin={true} permission="shippingAreas" action="view">
            <Dashboard activeTab={6}>
              <RegionTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/payment-gateways" element={
          <ProtectedRoute isAdmin={true} superAdminOnly={true}>
            <Dashboard activeTab={6}>
              <PaymentGatewaySettings />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/inventory-log" element={
          <ProtectedRoute isAdmin={true} permission="inventoryLog" action="view">
            <Dashboard activeTab={6}>
              <InventoryLog />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/wallets" element={
          <ProtectedRoute isAdmin={true} permission="wallet" action="view">
            <Dashboard activeTab={6}>
              <WalletTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/wallet/:userId" element={
          <ProtectedRoute isAdmin={true} permission="wallet" action="view">
            <Dashboard activeTab={6}>
              <WalletDetail />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/wallet-settings" element={
          <ProtectedRoute isAdmin={true} superAdminOnly={true}>
            <Dashboard activeTab={6}>
              <WalletSettings />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/stores" element={
          <ProtectedRoute isAdmin={true} permission="vendors" action="edit">
            <Dashboard activeTab={6}>
              <StoreTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/vendors" element={
          <ProtectedRoute isAdmin={true} permission="vendors" action="view">
            <Dashboard activeTab={6}>
              <VendorTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/vendor/new" element={
          <ProtectedRoute isAdmin={true} permission="vendors" action="create">
            <Dashboard activeTab={6}>
              <VendorForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/vendor/:id/edit" element={
          <ProtectedRoute isAdmin={true} permission="vendors" action="edit">
            <Dashboard activeTab={6}>
              <VendorForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/vendor/:id" element={
          <ProtectedRoute isAdmin={true} permission="vendors" action="view">
            <Dashboard activeTab={6}>
              <VendorAllocations />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/vendor/login" element={<VendorLogin />} ></Route>
        <Route path="/vendor/dashboard" element={<VendorDashboard />} ></Route>

        <Route path="/admin/drivers" element={
          <ProtectedRoute isAdmin={true} permission="drivers" action="view">
            <Dashboard activeTab={6}>
              <DriverTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/driver/new" element={
          <ProtectedRoute isAdmin={true} permission="drivers" action="create">
            <Dashboard activeTab={6}>
              <DriverForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/driver/:id" element={
          <ProtectedRoute isAdmin={true} permission="drivers" action="edit">
            <Dashboard activeTab={6}>
              <DriverForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/driver" element={<DriverPortal />} ></Route>

        <Route path="/admin/vehicles" element={
          <ProtectedRoute isAdmin={true} permission="vehicles" action="view">
            <Dashboard activeTab={6}>
              <VehicleTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/vehicle/new" element={
          <ProtectedRoute isAdmin={true} permission="vehicles" action="create">
            <Dashboard activeTab={6}>
              <VehicleForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/vehicle/:id" element={
          <ProtectedRoute isAdmin={true} permission="vehicles" action="edit">
            <Dashboard activeTab={6}>
              <VehicleForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/header" element={
          <ProtectedRoute isAdmin={true} permission="header" action="view">
            <Dashboard activeTab={6}>
              <HeaderAdmin />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/notifications" element={
          <ProtectedRoute isAdmin={true} permission="notifications" action="view">
            <Dashboard activeTab={6}>
              <NotificationTable />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/notification/new" element={
          <ProtectedRoute isAdmin={true} permission="notifications" action="create">
            <Dashboard activeTab={6}>
              <NotificationForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="/admin/notification/:id" element={
          <ProtectedRoute isAdmin={true} permission="notifications" action="edit">
            <Dashboard activeTab={6}>
              <NotificationForm />
            </Dashboard>
          </ProtectedRoute>
        } ></Route>

        <Route path="*" element={<NotFound />}></Route>

      </Routes>
      {!isAdminRoute && (
        <>
          <FooterInfoBar />
          <Footer />
        </>
      )}
    </>
  );
}

export default App;